import { atom, atomFamily, DefaultValue, selector } from "recoil"
import { BadgeHistoryIdsSetterAction } from "./types"
import { searchSort } from "../../../util/searh-sort"
import { currentVisibleOverlayAtom, showBadgeOverlayAtom } from "../overlay"
import { localUserIdAtom, usersSelector } from "../../atoms/users"
import { SortType } from "../../../constants/enums"

export const badgesHistoryAtom = atomFamily({
  key: "badgesHisroty",
  default: null
})

export const badgeHisrotyIdsAtom = atom<string[]>({
  key: "badgeHisrotyIdsAtom",
  default: []
})

export const badgeHisrotyIdsSelector = selector({
  key: "badgeHisrotyIdsSelector",
  get: ({ get }) => {
    return get(badgeHisrotyIdsAtom)
  },
  set: ({ set, reset, get }, action: any) => {
    if (action instanceof DefaultValue) {
      return false
    } else {
      const { name, badgeHistoryId, badgeHistoryData } =
        action as BadgeHistoryIdsSetterAction
      if (name === "ADD") {
        let badgeHistoryIdsArr = get(badgeHisrotyIdsAtom)
        const index = badgeHistoryIdsArr.indexOf(badgeHistoryId)

        if (index < 0) {
          set(badgesHistoryAtom(badgeHistoryId), badgeHistoryData)
          set(badgeHisrotyIdsAtom, badgeHistoryIds => [
            ...badgeHistoryIds,
            ...[badgeHistoryId]
          ])
        } else {
          set(badgesHistoryAtom(badgeHistoryId), prev => ({
            ...prev,
            ...badgeHistoryData
          }))
        }
      }

      if (name === "DELETE") {
        set(badgeHisrotyIdsAtom, prev =>
          prev.filter(el => el !== badgeHistoryId)
        )

        /* const historyOverlay = get(historyProductSelectorPropsAtom)
        if (historyOverlay?.id === badgeHistoryId) {
          set(historyProductSelectorPropsAtom, prev => ({
            ...prev,
            isProductDelete: true
          }))
        } */
      }

      if (name === "RESET") {
        set(badgeHisrotyIdsAtom, [])
      }
    }
  }
})

export const badgesHistoryFilterState = atom<{
  textField: string
  optionSort: string
}>({
  key: "badgesHistoryFilterState",
  default: {
    textField: "",
    optionSort: SortType.TIMESTAMP
  }
})

export const unFilterHistoryListSelector = selector({
  key: "unFilterHistoryListSelector",
  get: ({ get }) => {
    const badgeHistoryIdsList = get(badgeHisrotyIdsAtom)
    const userId = get(localUserIdAtom)
    const localUser = get(usersSelector(userId))

    const array = badgeHistoryIdsList
      .map(uid => get(badgesHistoryAtom(uid)))
      .filter(badge =>
        get(showBadgeOverlayAtom) && localUser?.type !== 3
          ? get(currentVisibleOverlayAtom)?.id !== badge?.id
          : true
      )
    return array
  }
})

//This is Badge History Object List used in the Bagde history tab
export const badgeHistoryListSelector = selector({
  key: "badgeHistoryListSelector",
  get: ({ get }) => {
    const badgeHistoryIdsList = get(badgeHisrotyIdsAtom)
    const value = get(badgesHistoryFilterState)
    const userId = get(localUserIdAtom)
    const localUser = get(usersSelector(userId))

    const sortArray = badgeHistoryIdsList
      .map(uid => get(badgesHistoryAtom(uid)))
      .sort(searchSort(value))
      .filter(badge =>
        get(showBadgeOverlayAtom) && localUser?.type !== 3
          ? get(currentVisibleOverlayAtom)?.id !== badge?.id
          : true
      )

    if (value.textField.length > 0) {
      return sortArray.filter(badge => {
        return badge.title.toLowerCase().match(value.textField.toLowerCase())
      })
    } else {
      return sortArray
    }
  }
})
